import { type FC } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import { useMergeFastCheckoutCart } from '@/Pages/BuyNowPage/hooks/useMergeFastCheckoutCart';
import ExitIntentIcon from '@/Pages/BuyNowPage/partials/icons/ExitIntent';

interface ExitIntentProps {
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
  href?: string;
}

const TITLE_LABEL = 'Falta poquito';
const DESCRIPTION_LABEL =
  'Tu compra está casi lista.¿Te gustaría terminar ahora?';
const EXIT_BUTTON_LABEL = 'Salir';
const COMPLETE_PURCHASE_BUTTON_LABEL = 'Completar compra';

const ExitIntentModal: FC<ExitIntentProps> = ({ isOpen, onClose, loading }) => {
  const { isLoading: isMerging, mergeAndRedirectToHome } =
    useMergeFastCheckoutCart();

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
      />
      <ModalBody className="co-flex co-flex-col co-p-6 co-pt-0 co-gap-4 co-mb-0 co-mt-0">
        <div>
          <div className="co-flex co-flex-col co-gap-2.5 co-p-3 co-pb-0 co-items-center">
            <ExitIntentIcon />
            <Text
              variant="subtitle1"
              weight={700}
              color="primary-500"
              className="mobile:co-text-20px mobile:co-leading-26px"
            >
              {TITLE_LABEL}
            </Text>
            <Text
              variant="body2"
              weight={400}
              fixed
              className="co-text-center co-text-balance"
            >
              {DESCRIPTION_LABEL}
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit">
        <Button
          block
          size="xl"
          variant="secondary"
          loading={isMerging}
          onClick={() => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.ExitModalSalir
              }
            });
            mergeAndRedirectToHome();
          }}
        >
          {EXIT_BUTTON_LABEL}
        </Button>
        <Button
          size="xl"
          variant="primary"
          onClick={() => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.ExitModalCompletarCompra
              }
            });
            onClose();
          }}
          loading={loading}
        >
          {COMPLETE_PURCHASE_BUTTON_LABEL}{' '}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ExitIntentModal;
